import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {goToPage} from '../../fundialSlice';

const PlaylistExceedError = (props) => {
  return (
    <section className='playlist-exceed-error'>
      <div className='title'>
        <Image src={require('./images/mark.svg')} alt='סימן קריאה' />
        <p>הגעתם למכסת השירים המקסימלית</p>
      </div>
      <p className='text bold'>איפה תוכלו לנהל את רשימת השירים שלכם?</p>
      <p className='text'>בכניסה להמתנה נעימה ביחרו באזור הניהול</p>
      <div className='songs-list-img'>
        <Image src={require('./images/songs.jpg')} alt='חץ' />
      </div> 
      <div className='another-song' role="button" onClick={() => props.goToPage({page: 'personalAreaPage'})}>
        <p>מעבר לאזור ניהול</p>
        <Image src={require('./images/arrow.svg')} alt='חץ' />
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {
  goToPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaylistExceedError);
